const badges = [
  {
    icon: "ri-team-line",
    label: "10,000+ Users",
    desc: "Worldwide Community",
    img: "https://readdy.ai/api/search-image?query=Diverse%20group%20of%20stylish%20young%20shoppers%20looking%20at%20products%20on%20a%20smartphone%20together%20outdoors%20in%20a%20bright%20city%20street%20setting%2C%20casual%20fashion%20clothing%2C%20golden%20afternoon%20sunlight%2C%20candid%20lifestyle%20photography%2C%20warm%20vibrant%20atmosphere%20with%20urban%20backdrop&width=400&height=280&seq=trust-badge-01-v3&orientation=landscape"
  },
  {
    icon: "ri-refresh-line",
    label: "Updated Weekly",
    desc: "Fresh Content Always",
    img: "https://readdy.ai/api/search-image?query=Modern%20digital%20workspace%20with%20a%20laptop%20screen%20showing%20a%20colorful%20spreadsheet%20interface%20being%20refreshed%2C%20calendar%20with%20weekly%20marks%2C%20coffee%20cup%20and%20green%20plant%20on%20a%20light%20oak%20wooden%20desk%2C%20bright%20morning%20natural%20light%2C%20clean%20productive%20aesthetic&width=400&height=280&seq=trust-badge-02-v3&orientation=landscape"
  },
  {
    icon: "ri-shield-check-line",
    label: "Secure Information",
    desc: "Verified Sellers Only",
    img: "https://readdy.ai/api/search-image?query=Closeup%20of%20hands%20holding%20a%20smartphone%20displaying%20a%20green%20verification%20checkmark%20badge%20against%20a%20soft%20white%20surface%2C%20shield%20security%20icon%20subtle%20in%20background%2C%20clean%20modern%20tech%20aesthetic%2C%20bright%20even%20studio%20lighting%2C%20trust%20and%20safety%20concept&width=400&height=280&seq=trust-badge-03-v3&orientation=landscape"
  },
  {
    icon: "ri-gift-line",
    label: "Free Access",
    desc: "No Payment Required",
    img: "https://readdy.ai/api/search-image?query=Open%20gift%20box%20with%20fashion%20items%20spilling%20out%20including%20a%20cap%20and%20accessories%20on%20a%20light%20gray%20concrete%20surface%2C%20confetti%20particles%20floating%20in%20air%2C%20warm%20festive%20lighting%20from%20above%2C%20joyful%20lifestyle%20product%20photography%2C%20modern%20clean%20aesthetic&width=400&height=280&seq=trust-badge-04-v3&orientation=landscape"
  },
];

export default function TrustBadges() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-50 border-b border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {badges.map((badge) => (
            <div key={badge.label} className="group bg-background-100/80 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
              {/* Image */}
              <div className="w-full h-28 md:h-32 overflow-hidden">
                <img
                  src={badge.img}
                  alt={`VigorBuy - ${badge.label}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="p-4 flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-lg bg-accent-100">
                  <i className={`${badge.icon} text-base text-accent-500`}></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground-950 font-heading">{badge.label}</p>
                  <p className="text-xs text-foreground-600 mt-0.5">{badge.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}